import * as React from 'react';

import type { SubscriptionTiersProductPrice } from 'bundles/coursera-plus-landing-page/contentfulData/LandingPageDataProvider';
import { useLandingPageExtended } from 'bundles/coursera-plus-landing-page/contentfulData/useLandingPageData';
import ReactPriceDisplay from 'bundles/payments-common/components/ReactPriceDisplay';

export type PropsFromUseCourseraPlusAnnualPricePresentation = {
  discountPercent: number | null;
  annualAmountPerMonthDisplay: JSX.Element | null;
  annualAmountPerMonth?: number;
  monthlyPriceDisplay: JSX.Element | null;
  courseraPlusMonthlyPrice?: SubscriptionTiersProductPrice;
  courseraPlusAnnualPrice?: SubscriptionTiersProductPrice;
  hasFreeTrial: boolean;
};

export const useCourseraPlusAnnualPricePresentation = (): PropsFromUseCourseraPlusAnnualPricePresentation => {
  const landingPageExtended = useLandingPageExtended();
  const { prices, userHasCourseraPlusFreeTrial } = landingPageExtended;
  const { primaryOriginalPrice: courseraPlusMonthlyPrice, secondaryPrice: courseraPlusAnnualPrice } = prices;

  let discountPercent = null;
  let annualAmountPerMonth: number | undefined = undefined;
  let annualAmountPerMonthDisplay: JSX.Element | null = null;
  let monthlyPriceDisplay: JSX.Element | null = null;

  if (courseraPlusMonthlyPrice && courseraPlusAnnualPrice) {
    annualAmountPerMonth = Math.ceil(courseraPlusAnnualPrice.amount / 12);
    const totalCourseraPlusMonthlyPriceInAYear = courseraPlusMonthlyPrice.amount * 12;
    discountPercent = Math.ceil(
      ((totalCourseraPlusMonthlyPriceInAYear - courseraPlusAnnualPrice.amount) / totalCourseraPlusMonthlyPriceInAYear) *
        100
    );
    annualAmountPerMonthDisplay = courseraPlusMonthlyPrice ? (
      <ReactPriceDisplay
        value={annualAmountPerMonth}
        currency={courseraPlusMonthlyPrice.currencyCode}
        hideCurrencyCode={true}
      />
    ) : null;
    monthlyPriceDisplay = courseraPlusMonthlyPrice ? (
      <ReactPriceDisplay
        value={courseraPlusMonthlyPrice.amount}
        currency={courseraPlusMonthlyPrice.currencyCode}
        hideCurrencyCode={true}
      />
    ) : null;
  }
  return {
    annualAmountPerMonthDisplay,
    annualAmountPerMonth,
    discountPercent,
    monthlyPriceDisplay,
    courseraPlusMonthlyPrice,
    courseraPlusAnnualPrice,
    hasFreeTrial: userHasCourseraPlusFreeTrial,
  };
};
